const GENERIC_DECLINE = 'Your card has been declined'

export const STRIPE_ERRORS = {
  card_declined_do_not_honor: GENERIC_DECLINE,
  card_declined_fraudulent: GENERIC_DECLINE,
  card_declined_generic_decline: GENERIC_DECLINE,
  card_declined_insufficient_funds: 'Your card has insufficient funds',
  card_declined_lost_card: GENERIC_DECLINE,
  card_declined_stolen_card: GENERIC_DECLINE,
  expired_card: 'Your card has expired',
  incorrect_cvc: "Your card's security code is incorrect",
  incorrect_zip: 'Your card number and postal code do not match',
  payment_intent_authentication_failure: 'We are unable to authenticate your payment method',
  processing_error: 'An error occurred while processing your card. Try again in a little bit'
}

export const STRIPE_ERRORS_EXTRA = {
  card_declined_generic_decline:
    'Please make sure you are using a debit card that is registered within Great Britain. We are unable to process credit card payments or payments from other countries.'
}
